import React from 'react';
import { StyledHeaderDirectory, StyledHeaderItem } from './style';

const HeaderData = ['Nombre', 'Apellidos', 'Cargo', 'Departamento'];

const HeaderDirectory = () => (
  <StyledHeaderDirectory>
    <StyledHeaderItem />
    {HeaderData.map((item, i) => (
      <StyledHeaderItem key={`header-g-${i + 1}`}>{item}</StyledHeaderItem>
    ))}
    <StyledHeaderItem />
  </StyledHeaderDirectory>
);

export default HeaderDirectory;
